<script setup lang="ts">
import DeleteEntityDialog from '@/common/components/DeleteEntityDialog.vue';
import { Assert } from 'shared/assert';
import { useTemplateRef } from 'vue';
import { useProductionOrderStore } from 'shared/productionOrders/stores/productionOrderStore';
import { useDeleteProductionOrderApi } from '../api/deleteProductionOrderApi';

const dialog = useTemplateRef('dialog');

defineExpose({
  show
});

const deleteApi = useDeleteProductionOrderApi();
const store = useProductionOrderStore();

function show(id: string) {
  dialog.value?.show(id);
}

async function onDelete(id: string) {
  const response = await deleteApi.execute({ id });
  return response;
}

async function getById(id: string) {
  const entity = store.getById(id);
  Assert.definied(entity);
  return {
    id: entity.id,
    name: entity.name
  };
}

</script>

<template>
  <DeleteEntityDialog ref="dialog" :delete="onDelete" :get-by-id="getById"
    :translate="(t) => t.productionOrders.deleteDialog">
  </DeleteEntityDialog>
</template>
